'use strict'

import ContestList from '@/pages/Contest/ContestList.vue'
import Contest from '@/pages/Contest/Contest.vue'
import RoundForm from '@/pages/Contest/RoundForm.vue'
import ifAuthenticated from '@/router/middleware'

export default [
  {
    path: '/:site/contests',
    name: 'Contests',
    component: ContestList,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/:site/contests/:id',
    name: 'Contest',
    component: Contest,
    beforeEnter: ifAuthenticated,
    props: true
  },
  {
    path: '/:site/contests/:idContest/round/create',
    name: 'round-create',
    component: RoundForm,
    beforeEnter: ifAuthenticated,
    props: true
  },
  {
    path: '/:site/contests/:idContest/round/:id',
    name: 'round-edit',
    component: RoundForm,
    beforeEnter: ifAuthenticated,
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/router/domains/contest.js